import { ReducerActionRotaSP } from 'store/modules/types';

import { Types } from './types';

export function paisRequest(
	token: string,
	payload: string,
): ReducerActionRotaSP {
	return {
		type: Types.PAIS,
		token,
		payload,
	};
}
export function paisSuccess(payload: []): ReducerActionRotaSP {
	return {
		type: Types.PAIS_SUCCESS,
		payload,
	};
}
export function paisFailure(payload: []): ReducerActionRotaSP {
	return {
		type: Types.PAIS_FAILURE,
		payload,
	};
}

export function paisClear(): { type: string } {
	return {
		type: Types.PAIS_CLEAR,
	};
}
